import _ from 'lodash'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

// import { Link } from 'react-router';
import { Icon, Button, Segment, Grid, TextArea } from 'semantic-ui-react'

import ServicesTable from './minions/ServicesTable'

class MinionList extends PureComponent {
  static contextTypes = {
    app: PropTypes.shape({
      actions: PropTypes.objectOf(PropTypes.func),
    })
  }
  static propTypes = {
    minions: PropTypes.object,
  }
  state = {
    grainsOpen: {},
    servicesOpen: {},
    services: {}
  }

  _getOtherKeys = (thisKey) => {
    return _
      .chain(this.state)
      .toPairs()
      .filter(pair => pair[0].endsWith('Open') && pair[0] !== thisKey)
      .fromPairs()
      .keys()
      .value()
  }

  _getFetcherFunction = (what) => {
    return _
      .chain(this.context.app.actions || {})
      .find((v, k) => k === `get${_.capitalize(what)}`)
      .value()
  }

  _getActionsForServices () {
    return _
      .chain(this.context.app.actions)
      .map((action, name) => {
        if(!_.includes(
          [
            'serviceStart',
            'serviceStop',
            'serviceRestart',
            'serviceEnable',
            'serviceDisable',
          ],
          name)) return null
        return [name.replace('service', '').toLowerCase(), action]
      })
      .filter()
      .fromPairs()
      .value()
  }

  toggleOpen = (mid, what) => {
    const thisKey = `${what}Open`
    const nowIsOpen = this.state[thisKey][mid]||false
    const otherKeys = this._getOtherKeys(thisKey)
    const fetcherFunction = this._getFetcherFunction(what)

    if(_.isFunction(fetcherFunction) && _.isUndefined(this.state[what][mid])) {
      this.setState({[what]: {...this.state[what], [mid]:'loading'}})
      return fetcherFunction(mid).then(res => {
        this.setState({[what]: {...this.state[what], [mid]: res[mid]}})
        this.toggleOpen(mid, what)
      })
    }

    let newState = {[thisKey]: {...this.state[thisKey], [mid]:!nowIsOpen}}
    if(!nowIsOpen)
      _.forEach(otherKeys, oKey => {
        newState[oKey] = {...this.state[oKey], [mid]: false}
      })
    this.setState(newState, () => { console.log(`after toggle ${what}:`, this.state[thisKey], mid) })
  }

  render () {

    const minions = _.map(this.props.minions, (v, m) => {
      return (
        <Segment.Group key={m}>
          <Grid.Row>
            <Grid columns={'equal'}>

              <Grid.Column width={4}>
                <Grid.Row>
                  <h1>{m}</h1>
                </Grid.Row>

                <Grid.Row textAlign={'center'}>
                  <Button.Group size={'mini'}>
                    <Button
                      onClick={() => this.toggleOpen(m, 'grains')}>
                      <Icon name={(
                          this.state.grainsOpen[m] ?
                          'triangle down' : 'triangle right'
                      )} /> grains
                    </Button>
                    <Button
                      loading={this.state.services[m] === 'loading'}
                      onClick={() => this.toggleOpen(m, 'services')}>
                      <Icon name={(
                          this.state.servicesOpen[m] ?
                          'triangle down' : 'triangle right'
                      )} /> services
                    </Button>
                  </Button.Group>
                </Grid.Row>

              </Grid.Column>

              <Grid.Column>
                <Grid.Row>
                  <h6>{v.fingerprint}</h6>
                </Grid.Row>
                <Grid.Row>
                  <Icon name={v.status ? 'check circle' : 'remove circle'} />
                </Grid.Row>
              </Grid.Column>
            </Grid>
          </Grid.Row>

          {(this.state.grainsOpen[m] && v.grains) && (
             <Grid.Row>
               <TextArea
                 autoHeight readOnly style={{minWidth: '100%'}}
                 value={
                   JSON.stringify(v.grains, null, 4).replace(
                     /([^\\])?\\n/g,
                     '$1' + String.fromCharCode(13, 10))}
               />
             </Grid.Row>
          )}
          {(this.state.servicesOpen[m] && this.state.services[m]) && (
             <Grid.Row>
               <ServicesTable
                 mid={m} services={this.state.services[m]}
                 actions={this._getActionsForServices()}
               />
             </Grid.Row>
          )}
        </Segment.Group>
      )
    })
    return (
      /*<Segment.Group>{minions}</Segment.Group>*/
      <Segment>{minions}</Segment>
    )
  }
}
//MinionList.displayName = 'MinionList'

export default MinionList



// WEBPACK FOOTER //
// ./src/components/MinionList.js